module.exports = __webpack_public_path__ + "static/key-soulcalibur-9838a65f1225345828c9e4fa2ad2f073.webp";